// extracted by mini-css-extract-plugin
module.exports = {"description":"List_description__BBQD9","listItem":"List_listItem__ZWINg","optionLabel":"List_optionLabel__RkHXR","list":"List_list__eNEr4"};